module.exports = __webpack_public_path__ + "static/media/talha-anis-profile.76b9b534.jpg";